import React from 'react';
import PageWrapper from '../../components/page-wrapper/page-wrapper';
import BlogDisplay from '../../components/blog-display/blog-display';

const BlogPostPage = () => {
  return (
    <PageWrapper>
      <div className="container mt-5 pt-5">
        <div className="row">
          <div className="col-12">
            <BlogDisplay />
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};

export default BlogPostPage;